(() => {
  const targets='a.jdgm-medal[aria-label],.lb-bundle-products';
  function fixElement(element){
    if(element.matches('a.jdgm-medal[aria-label]')){
      const link=element;
      const visible=link.textContent.trim(),name=link.getAttribute('aria-label');
      if(visible && !name.includes(visible))link.setAttribute('aria-label',visible+' — '+name);
    }
    if(element.matches('.lb-bundle-products')){
      const list=element;
      if(list.querySelector(':scope > [role="listitem"]') && list.getAttribute('role')!=='list')list.setAttribute('role','list');
      if(!list.closest('[data-product-handle="vunro-d-series-clipper"]'))return;
      const bundle=list;
      const walker=document.createTreeWalker(bundle,NodeFilter.SHOW_TEXT);
      let node;while((node=walker.nextNode())){
        if(node.parentElement.closest('script,style'))continue;
        const text=node.nodeValue.replace(/Extra Trimmer Blade/g,'Extra Clipper Blade');
        if(text!==node.nodeValue)node.nodeValue=text;
      }
    }
  }
  document.querySelectorAll(targets).forEach(fixElement);
  const root=document.querySelector('main');
  if(!root)return;
  let scheduled=false;
  const pending=new Set();
  const observer=new MutationObserver(records=>{
    records.forEach(record=>{
      const owner=record.target.nodeType===1 && record.target.closest(targets);
      if(owner)pending.add(owner);
      record.addedNodes.forEach(node=>{
        if(node.nodeType!==1)return;
        if(node.matches(targets))pending.add(node);
        node.querySelectorAll(targets).forEach(element=>pending.add(element));
      });
    });
    if(scheduled||!pending.size)return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;pending.forEach(fixElement);pending.clear();});
  });
  observer.observe(root,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),30000);
})();
(() => {
  if (window.__vunroCartCutterMatch) return;
  window.__vunroCartCutterMatch = true;
  const widgetSelector = 'lb-upsell-widget[widget="widget#icuc"]';
  const initialized = new WeakMap(), pending = new Set(), products = new Map();
  let cartRequest, scheduled = false;
  const bodies = {
    'replacement-a5-cutter': 'standard', 'replacement-a5-cutter-blue-steel': 'standard',
    'replacement-ceramic-a5-cutter': 'standard',
    '40-50-replacement-a5-cutter-steel': '4050', '40-50-blade-replacement-cutter-ceramic': '4050',
    'replacement-a5-wide-cutter-steel': 'wide', 'replacement-a5-wide-cutter-ceramic': 'wide',
    'replacement-a5-skip-tooth-cutter-ceramic': 'skip', 'replacement-d-series-cutter-ceramic': 'dseries'
  };
  async function triggerProduct(id) {
    if (products.has(id)) return products.get(id);
    if (!cartRequest) cartRequest = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}})
      .then(response => response.ok ? response.json() : null)
      .then(cart => { (cart?.items || []).forEach(item => products.set(String(item.product_id), item)); })
      .catch(() => {}).finally(() => {cartRequest = null;});
    await cartRequest;
    return products.get(id);
  }
  async function match(widget) {
    const id = widget.getAttribute('lb-trigger-product-id');
    const selects = [...widget.querySelectorAll('[lb-product-handle] select')].filter(select => {
      const handle = select.closest('[lb-product-handle]').getAttribute('lb-product-handle');
      return bodies[handle] && initialized.get(select) !== id;
    });
    if (!id || !selects.length) return;
    const product = await triggerProduct(id);
    if (!product || !widget.isConnected || widget.getAttribute('lb-trigger-product-id') !== id) return;
    const handle = product.handle || (product.url || '').split('/products/')[1]?.split('?')[0] || '';
    if (/cutter|bundle|kit|set/.test(handle)) return;
    const size = handle.match(/^(\d+(?:f)?w?)-/)?.[1];
    if (!size || !/blade/.test(handle)) return;
    const body = /d-series/.test(handle) ? 'dseries' : /skip-tooth/.test(handle) ? 'skip' : /w$/.test(size) ? 'wide' : /^(40|50)$/.test(size) ? '4050' : 'standard';
    selects.forEach(select => {
      if (!select.isConnected || initialized.get(select) === id) return;
      initialized.set(select, id);
      const card = select.closest('[lb-product-handle]');
      if (bodies[card.getAttribute('lb-product-handle')] !== body) return;
      const option = [...select.options].find(option => !option.disabled && !/sold out|unavailable/i.test(option.textContent) &&
        (option.textContent.toLowerCase().match(/\d+[a-z]*/g) || []).some(value => value.replace(/w$/, '') === size.replace(/w$/, '')));
      if (option && select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }
  function queue(widget) {
    if (!widget) return;
    pending.add(widget);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; pending.forEach(widget => void match(widget)); pending.clear();});
  }
  document.querySelectorAll(widgetSelector).forEach(queue);
  document.addEventListener('change', event => {
    const select = event.target;
    const widget = select.matches?.('select') && select.closest(widgetSelector);
    if (widget) initialized.set(select, widget.getAttribute('lb-trigger-product-id'));
  }, true);
  const observer = new MutationObserver(records => records.forEach(record => {
    const owner = record.target.nodeType === 1 && record.target.closest(widgetSelector);
    if (owner) queue(owner);
    record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches(widgetSelector)) queue(node);
      else node.querySelectorAll(widgetSelector).forEach(queue);
    });
  }));
  document.querySelectorAll('cart-drawer,#main-cart-footer').forEach(root => observer.observe(root,
    {childList:true, subtree:true, attributes:true, attributeFilter:['lb-trigger-product-id']}));
})();


(() => {
  const selector = '.Avada-CookiesBar__Reopen-Popup';
  const controls = 'a,button,[role="button"],input:not([type="hidden"]),select,textarea,summary,.button,.vbb-button,iframe:not(#PBarNextFrame),.sticky-atc-bar,.vnailp__sticky,.vwhet__sticky,.vdevice__sticky,.va5-top-pick';
  let pending = false;
  let targets = [];
  let dirty = true;
  const intersects = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  function update() {
    pending = false;
    const button = document.querySelector(selector);
    if (!button) return;
    const name = button.textContent.trim();
    if (name && button.title !== name) button.title = name;
    if (dirty) {
      targets = [...document.querySelectorAll(controls)];
      dirty = false;
    }
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    const width = document.documentElement.clientWidth;
    const buttonStyle = getComputedStyle(button);
    const right = parseFloat(buttonStyle.right) || 12;
    // The badge's bottom is fixed at 12px plus the safe area; the dodge is a transform (22 October 2026).
    const safeBottom = Math.max(0, (parseFloat(buttonStyle.bottom) || 12) - 12);
    const left = width - right - 44;
    const obstacles = targets.filter(element => element.isConnected && !element.closest('#Avada-CookiesBar')).map(element => {
      const rect = element.getBoundingClientRect();
      if (element.tagName === 'A' && rect.height > 80 && !element.matches('.button,[role="button"]')) return null;
      if (!rect.width || !rect.height || rect.right <= left - 8 || rect.left >= width - right + 8 || rect.bottom <= 0 || rect.top >= height) return null;
      const style = getComputedStyle(element);
      return style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0 || style.pointerEvents === 'none' ? null : rect;
    }).filter(Boolean);
    const header = document.querySelector('.section-header');
    const headerRect = header && header.getBoundingClientRect();
    const ceiling = Math.max(12, headerRect && headerRect.top < height ? headerRect.bottom + 12 : 12);
    let top = height - 56 - safeBottom;
    for (let index = 0; index <= obstacles.length; index++) {
      const box = {left: left - 8, right: width - right + 8, top: top - 8, bottom: top + 52};
      const overlap = obstacles.filter(rect => intersects(box, rect));
      if (!overlap.length) break;
      top = Math.min(...overlap.map(rect => rect.top)) - 52;
    }
    const obstructed = top < ceiling;
    if (button.dataset.vunroObstructed !== String(obstructed)) button.dataset.vunroObstructed = String(obstructed);
    const bottom = Math.max(12, window.innerHeight - top - 44 - safeBottom) + 'px';
    if (button.style.getPropertyValue('--vunro-cookie-bottom') !== bottom) button.style.setProperty('--vunro-cookie-bottom', bottom);
  }
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(records => {
    if (!records.some(record => record.type === 'childList' || !record.target.matches(selector))) return;
    dirty = true;
    queue();
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden']});
  window.addEventListener('scroll', queue, {passive: true});
  window.addEventListener('resize', queue, {passive: true});
  window.visualViewport?.addEventListener('resize', queue, {passive: true});
  window.visualViewport?.addEventListener('scroll', queue, {passive: true});
  document.addEventListener('load', queue, true);
  document.addEventListener('toggle', queue, true);
  document.addEventListener('transitionend', queue, true);
  window.addEventListener('pageshow', queue);
  queue();
})();

(() => {
  // Cart drawer suggestions (22 October 2026): Selleasy's product name and price are plain text, and shoppers tapped them
  // expecting the product. Those taps now go to the card's image link, which Selleasy already handles.
  const text = '.lb-card-title,.lb-addon-title,.lb-addon-subTitle,[class*="lb-price"]';
  const controls = 'a[href],button,label,select,input,textarea,.lb-button,[role="button"],lb-card-image,.lb-card-image';
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const card = target && target.closest('[lb-product-handle]');
    if (!card || !target.closest(text) || target.closest(controls)) return;
    event.preventDefault();
    event.stopPropagation();
    const image = card.querySelector('lb-card-image,.lb-card-image');
    if (image) image.click();
    else window.location.href = (window.Shopify?.routes?.root || '/') + 'products/' + card.getAttribute('lb-product-handle');
  }, true);
})();
